export default function Hero({ desktopImageSrc, opacity, children }) {
  return (
    <section className='hero'>
      {children}

      <style jsx>{`
        .hero {
          width: 100%;
          min-height: 57.4rem;
          height: 50vh;
          max-height: 100rem;
          padding: 8.4rem 0 0;
          background-blend-mode: color;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }

        @media (max-width: 1024px) {
          .hero {
            min-height: 24rem;
            height: unset;
            max-height: unset;
            padding: 2.5rem 0 0;
          }
        }
      `}</style>

      <style jsx>{`
        .hero {
          background-image: url(${desktopImageSrc});
          background-color: ${opacity != null
            ? `rgba(255,255,255, ${1 - opacity})` // as we use color blending, we revert opacity. 0.05 is achieved by 0.95 of blending
            : `rgba(255,255,255, 0.88)`};
        }
      `}</style>
    </section>
  )
}
